const BatchCaptureView = async () => import('@/views/effort/BatchCaptureView.vue')

/** @return {import('vue-router').RouteRecordRaw[]} */
export default [
  {
    path: '/effort/batch-capture',
    name: 'effort_batch-capture',
    component: BatchCaptureView,
    meta: { title: 'Leistung-Massenerfassung' }
  }
]
